import axios from "axios";
import {
  CORRECTIONS_QUERY_KEY,
  TRANSACTIONS_QUERY_KEY,
  TRANSACTION_ACTIVITIES_QUERY_KEY,
} from "consts";
import { queryCache, useMutation } from "react-query";
import { ChangeAssignee } from "../types";

const changeAssignee = async ({ ids, assigneeId: userId }: ChangeAssignee) => {
  const isBulkAssign = ids.length > 1;
  const { data } = isBulkAssign
    ? await axios.post("transactions/bulkAssign", {
        transactionsIds: ids,
        userId,
      })
    : await axios.post("transactions/assign", {
        transactionId: ids[0],
        userId,
      });

  return data;
};

const useAssignTransactions = () =>
  useMutation(changeAssignee, {
    throwOnError: true,
    onSuccess: () => {
      queryCache.invalidateQueries(TRANSACTIONS_QUERY_KEY);
      queryCache.invalidateQueries(CORRECTIONS_QUERY_KEY);
      queryCache.invalidateQueries(TRANSACTION_ACTIVITIES_QUERY_KEY);
    },
  });

export default useAssignTransactions;
